export default function classNames(
  classes?: Array<string | undefined>,
  conditionalClasses?: { [key: string]: unknown }
): string {
  const conditionalClassNames = conditionalClasses
    ? Object.entries(conditionalClasses)
        .filter(([, value]) => !!value)
        .map(([key]) => {
          return key;
        })
    : [];

  return `${
    classes?.filter((v) => !!v).join(' ') || ''
  } ${conditionalClassNames.join(' ')}`.trim();
}
